import Image from "next/image";

const FooterLogo = ({mediaBaseUrl, footerFirstSection}) =>{
    return(
        <div className="footerLogo">
                <Image
                  src={`${mediaBaseUrl}${footerFirstSection?.logo}`}
                  width={250}
                  height={80}
                  alt="Simpolo"
                 loading="lazy"
                //  rel="preload"
                //  priority={true}
                />
              </div>
    )
}

export default FooterLogo;